import { IdentProviderModel } from '../ident-provider/ident-provider.model';
import { PolicyMergeStrategy } from '../policy-model-v1';

// trial === f5 trial, full-featured | demo === UDF-created, full-featured, populated with mock data
export type OrgMode = 'trial' | 'platform' | 'demo';

export type OrgBasicInfo = {
  name: string;
  mode: OrgMode;
  policyEngine: OrgPolicyEngine;
  enablePortalChat: boolean;
};

export type OrgExternalReferences = {
  workos?: {
    workosOrganizationId?: string;
  };
};

export type OrgIdentityConfig = {
  gcipTenantId: string;
  providers: IdentProviderModel[]; // @todo add other provider types
};

export type OrgBrandingTheme = 'light' | 'dark';

export type OrgBranding = {
  lightThemeLogo: string;
  darkThemeLogo: string;
  portalBadge: {
    image: string;
    darkImage: string;
    title: string;
  };
  portalWelcome: {
    title: string;
    message: string;
    learnMoreLink: string;
  };
  supportEmail: string;
  acceptableUsePolicyURL: string;
  favicon: string;
  warnings: {
    publicServiceBlocked: string;
    publicServiceSensitiveData: string;
    privateServiceIntentBlocked: string;
  };
};

export type OrgPolicyEngine = {
  version: string;
  mergeStrategy: PolicyMergeStrategy;
};

type DataRetentionSetting = {
  key: 'conversationRetentionDays' | 'requestMetadataRetentionDays';
  label: string;
  description: string;
};

export const DATA_RETENTION_SETTINGS: DataRetentionSetting[] = [
  {
    key: 'conversationRetentionDays',
    label: 'User Conversation Retention Period',
    description:
      'The period of time for which user conversation data within the request is retained.',
  },
  {
    key: 'requestMetadataRetentionDays',
    label: 'Request Metadata Retention Period',
    description: 'The period of time for which request metadata is retained.',
  },
];
